/*============================================================================
  Iron — tiroir newsletter « offre de bienvenue -5 % ».
  Apparition APRÈS un petit scroll (non-intrusif, pas de pop-up bloquante).
  Refermable + mémorisé (localStorage) : ne se re-propose pas avant 30 jours
  après fermeture, jamais après inscription.
  États post-soumission (page rechargée par le form natif) : remerciement
  (auto-fermeture) ou ré-affichage de l'erreur de saisie.
  Markup + styles : snippet iron-newsletter-drawer.liquid (rendu dans theme.liquid).
==============================================================================*/
(function () {
  var root = document.querySelector('[data-iron-nldrawer]');
  if (!root) return;

  var KEY = 'iron_nl_drawer_v1';
  var SHOW_AT = 500;          // px de scroll avant apparition
  var DISMISS_DAYS = 30;      // délai avant de re-proposer après une fermeture
  var DONE_AUTOHIDE = 6000;   // auto-fermeture du message de remerciement
  var design = !!(window.Shopify && window.Shopify.designMode);

  function store(state) {
    if (design) return; // l'aperçu customizer ne doit pas polluer la suppression
    try { localStorage.setItem(KEY, JSON.stringify({ s: state, t: Date.now() })); } catch (e) {}
  }
  function suppressed() {
    var v;
    try { v = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { v = null; }
    if (!v) return false;
    if (v.s === 'subscribed') return true;
    if (v.s === 'dismissed') {
      return (Date.now() - (v.t || 0)) < DISMISS_DAYS * 864e5;
    }
    return false;
  }

  var openTimer = null;
  function open() { root.classList.add('is-open'); root.removeAttribute('inert'); }
  function close() { clearTimeout(openTimer); root.classList.remove('is-open'); root.setAttribute('inert', ''); }
  function dismiss() { store('dismissed'); close(); }

  var done = root.querySelector('[data-nld-done]');
  var err = root.querySelector('[data-nld-error]');
  var isDone = !!done;
  function closeOrDismiss() { if (isDone) { close(); } else { dismiss(); } }

  // Fermeture (croix + Échap) active dans tous les états.
  root.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-nld-close]')) closeOrDismiss();
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && root.classList.contains('is-open')) closeOrDismiss();
  });

  // États post-soumission (rechargement natif du form).
  if (done) { store('subscribed'); open(); openTimer = setTimeout(close, DONE_AUTOHIDE); return; }
  if (err) { open(); return; }

  if (!design && suppressed()) return;

  // Aperçu customizer : montrer sans condition (le merchant doit pouvoir le voir).
  if (design) { setTimeout(open, 600); return; }

  // Déclenchement au scroll.
  var shown = false;
  function onScroll() {
    if (shown) return;
    var y = window.scrollY || window.pageYOffset || 0;
    if (y > SHOW_AT) {
      shown = true;
      window.removeEventListener('scroll', onScroll);
      open();
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // si la page est déjà scrollée (rechargement à mi-page)
})();
